import { render } from "./CoveragePage.vue?vue&type=template&id=7caa0e35"
import script from "./CoveragePage.vue?vue&type=script&lang=js"
export * from "./CoveragePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__